module.exports = __webpack_public_path__ + "img/compact.5f3d6729.png";